export default __webpack_public_path__ + "static/media/ecom_1.232faa44.jpg";